import { createPopper } from '@popperjs/core';
import React, { useState } from 'react';
import useMediaQuery from '@/Utils/useMediaQuery';

type Props = {
  Btn: React.FC;
  content: string;
  largerText?: boolean;
};

const Popover: React.FC<Props> = ({ content, Btn, largerText = false }) => {
  const [popoverShow, setPopoverShow] = React.useState(false);
  const btnRef = React.useRef<HTMLDivElement>(null);
  const popoverRef = React.useRef<HTMLDivElement>(null);

  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const openPopover = () => {
    setPopoverShow(true);
    createPopper(btnRef.current!, popoverRef.current!, {
      placement: 'top',
    });
  };
  const closePopover = () => {
    setPopoverShow(false);
  };

  return (
    <div className='flex flex-wrap'>
      <div className='w-full text-center'>
        <div
          className='border-none p-0 bg-transparent popover-icon'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            popoverShow ? closePopover() : openPopover();
          }}
          onMouseEnter={isDesktop ? openPopover : undefined}
          onMouseLeave={isDesktop ? closePopover : undefined}
          ref={btnRef}
        >
          <Btn />
        </div>
        <div
          className={
            (popoverShow ? 'block ' : 'hidden ') +
            'bg-white text-black font-serif ' +
            'border-1 border-solid border-inputBorder z-101 font-normal leading-normal text-lg text-left no-underline rounded-lg p-2 tooltips'
          }
          ref={popoverRef}
        >
          <pre
            className={`p-3 color-customBlack text-14px font-serif font-normal max-w-sm whitespace-pre-wrap ${
              largerText ? 'text-xl' : ''
            }`}
          >
            {content}
          </pre>
        </div>
      </div>
    </div>
  );
};
export default Popover;
// export default function PopoverRender() {
//   return (
//     <>
//       return <Popover color="pink" />
//     </>
//   );
// }
